import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './Home';
import Admin from './Admin';
import Results from './Results';
import SuperAdmin from './SuperAdmin';

function App() {
  return (
    <Router>
      <div style={{ padding: '1rem', background: '#f0f0f0' }}>
        <Link to="/" style={{ margin: '0 1rem', textDecoration: 'none' }}>Home</Link>
        <Link to="/results" style={{ margin: '0 1rem', textDecoration: 'none' }}>Results</Link>
        <Link to="/admin" style={{ margin: '0 1rem', textDecoration: 'none' }}>Admin</Link>
        <Link to="/super-admin" style={{ margin: '0 1rem' }}>Super Admin</Link>
        
      </div>
      <div style={{ padding: '1rem' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/results" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/super-admin" element={<SuperAdmin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;